import script from "./SchemaDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchemaDetail.vue?vue&type=script&setup=true&lang=ts"

import "./SchemaDetail.vue?vue&type=style&index=0&id=28f4e911&lang=css"

const __exports__ = script;

export default __exports__